let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
      .then(res => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
